import {IVendorNames, IVendor} from 'types/payment';

export const vendorData: Record<IVendorNames, IVendor> = {
  visa: {
    id: '1',
    displayName: 'Visa',
    name: 'visa',
    image: './images/payout_vendors/visa.svg',
    priceRange: {
      min: '2',
      max: '200',
    },
    bonus: null,
    withdrawalFee: 0,
    withdrawalMinimumFee: 0,
    withdrawalFeeText: 'Free',
    description:
      'Receive funds to a new Visa digital prepaid card. It can be used for online purchases, is valid in 215 countries, non-reloadable, and expires in 6 months.',
    availableAmounts: [
      { amount: '2', fee: '0' },
      { amount: '5', fee: '0' },
      { amount: '10', fee: '0' },
      { amount: '25', fee: '0' },
      { amount: '50', fee: '0' },
      { amount: '75', fee: '0' },
      { amount: '100', fee: '0' },
      { amount: '150', fee: '0' },
      { amount: '200', fee: '0' },
    ],
  },
  paypal: {
    id: '2',
    displayName: 'Paypal',
    name: 'paypal',
    image: './images/payout_vendors/paypal.svg',
    priceRange: {
      min: '2',
      max: '200',
    },
    bonus: '',
    withdrawalFee: 0.04,
    withdrawalMinimumFee: 0.25,
    withdrawalFeeText: '4% or minimum 0.25$',
    description:
      'PayPal allows you to receive funds directly to your PayPal account. The money can be used for online purchases or transferred to your bank.',
    availableAmounts: [
      { amount: '2', fee: '0' },
      { amount: '5', fee: '0' },
      { amount: '10', fee: '0' },
      { amount: '25', fee: '0' },
      { amount: '50', fee: '0' },
      { amount: '75', fee: '0' },
      { amount: '100', fee: '0' },
      { amount: '150', fee: '0' },
      { amount: '200', fee: '0' },
    ],
  },
  amazon: {
    id: '3',
    displayName: 'Amazon',
    name: 'amazon',
    image: './images/payout_vendors/amazon.svg',
    priceRange: {
      min: '2',
      max: '200',
    },
    bonus: null,
    withdrawalFee: 0,
    withdrawalMinimumFee: 0,
    withdrawalFeeText: 'Free',
    description:
      'Get an Amazon gift card that can be used to purchase millions of items. Valid for online shopping on Amazon.',
    availableAmounts: [
      { amount: '2', fee: '0' },
      { amount: '5', fee: '0' },
      { amount: '10', fee: '0' },
      { amount: '25', fee: '0' },
      { amount: '50', fee: '0' },
      { amount: '75', fee: '0' },
      { amount: '100', fee: '0' },
      { amount: '150', fee: '0' },
      { amount: '200', fee: '0' },
    ],
  },
  ggplay: {
    id: '4',
    displayName: 'Google Play',
    name: 'ggplay',
    image: './images/payout_vendors/ggplay.svg',
    priceRange: {
      min: '5',
      max: '200',
    },
    bonus: null,
    withdrawalFee: 0,
    withdrawalMinimumFee: 0,
    withdrawalFeeText: 'Free',
    description:
      'Redeem a Google Play gift card to purchase apps, games, movies, and more from the Google Play store.',
    availableAmounts: [
      { amount: '5', fee: '0' },
      { amount: '10', fee: '0' },
      { amount: '25', fee: '0' },
      { amount: '50', fee: '0' },
      { amount: '75', fee: '0' },
      { amount: '100', fee: '0' },
      { amount: '150', fee: '0' },
      { amount: '200', fee: '0' },
    ],
  },
};
